import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const DateRangeFilter = ({ startDate, setStartDate, endDate, setEndDate }) => {
  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  return (
    <div className="flex items-center">
      <DatePicker
        selected={startDate}
        onChange={handleDateChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange={true}
        isClearable={true}
        placeholderText="Select date range"
        className="w-full sm:w-64 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-black dark:bg-boxdark-2 dark:border-gray-600 dark:placeholder-gray-400"
        dateFormat="yyyy-MM-dd"
        maxDate={new Date()}
      />
    </div>
  );
};

export default DateRangeFilter; 